export const ROUTE_PATHS = {
  HOME: "/",
} as const;

export interface Service {
  id: string;
  title: string;
  description: string;
  icon: string;
}

export interface Testimonial {
  id: string;
  name: string;
  role: string;
  content: string;
  rating: number;
  avatar: string;
}

export interface PortfolioItem {
  id: string;
  title: string;
  category: string;
  image: string;
  link: string;
}

export interface WhyChooseCard {
  id: string;
  title: string;
  description: string;
  icon: string;
}

export const cn = (...inputs: (string | undefined | null | boolean | { [key: string]: boolean })[]) => {
  return inputs
    .filter(Boolean)
    .map((input) => {
      if (typeof input === "object" && input !== null) {
        return Object.entries(input)
          .filter(([_, value]) => value)
          .map(([key]) => key)
          .join(" ");
      }
      return input;
    })
    .join(" ");
};

export const scrollToSection = (sectionId: string) => {
  const element = document.getElementById(sectionId);
  if (element) {
    const headerOffset = 80;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }
};
